export default "__VITE_ASSET__Cr_6vnz$__"